import Grid from '@material-ui/core/Grid';

import styles from '../Form.module.scss';

interface PersonalDetailsHeaderProps {
  restrictGuTeamsForPa: boolean;
}

const PersonalDetailsHeader = ({ restrictGuTeamsForPa }: PersonalDetailsHeaderProps) => {
  if (restrictGuTeamsForPa) {
    return (
      <Grid container spacing={2} alignItems="center" className={styles.personalDetailsHeader}>
        <Grid item sm={6}>
          <p className={styles.formTitle}>Personal Details</p>
        </Grid>
        <Grid item sm={6}>
          <Grid container spacing={2}>
            <Grid item sm={6} />
            <Grid item sm={6}>
              <p className={styles.formNoteInline}>
                Note: you may only assign a Global User to teams to which you have access{' '}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }

  return (
    <div className={styles.personalDetailsTitleOnly}>
      <p className={styles.formTitle}>Personal Details</p>
    </div>
  );
};

export default PersonalDetailsHeader;
